import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';

import TaraText from './TaraText';

const Col = glamorous.div({
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  animationDelay: '1600ms',
  transition: 'height 300ms cubic-bezier(0, 0, 0.2, 1) 0ms',
});

const styleContainer = {
  display: 'flex',
  flexDirection: 'column',
  marginBottom: 32,
};

const noop = () => {};

const CHILD_HEIGHT = 48;
const CHILD_SPACING = 16;

const getHeight = children => ((CHILD_HEIGHT + CHILD_SPACING) * children.length) - CHILD_SPACING;

class TaraQuestion extends React.PureComponent {
  static propTypes = {
    isAnimated: PropTypes.bool,
    isCollapsed: PropTypes.bool,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    isAnimated: false,
    isCollapsed: false,
    onClick: noop,
  };

  createHandleClick = (value) => (e) => {
    this.props.onClick(value);
  };

  render() {
    const {
      children,
      isAnimated,
      isCollapsed,
      text,
    } = this.props;

    return (
      <div style={styleContainer} ref={this.props.questionRef}>
        <TaraText
          isQuestion
          isAnimated={isAnimated}
        >
          {text}
        </TaraText>
        <Col style={{ height: isCollapsed ? CHILD_HEIGHT : getHeight(children) }} className={isAnimated ? 'animated fadeIn' : undefined}>
          {children}
        </Col>
      </div>
    );
  }
}

export default TaraQuestion;



// WEBPACK FOOTER //
// ./src/components/features/Tara/TaraQuestion.js